import { Sprite } from "@babylonjs/core/Sprites/sprite";
import { IHotspot } from "./IHotspot";
import { SpriteManager, Vector3 } from "@babylonjs/core";
import { SpriteHelper } from "../util/SpriteHelper";
import { trigger } from "../util/EventManager";
import { HoverHelper } from "../util/HoverHelper";
import { ContentManager } from "../util/ContentHelper";
import { CameraHelper } from "../util/CameraHelper";

export class Hotspot implements IHotspot {

  sprite: Sprite;
  id: number;
  size: number = .3;

  clickFunction: Function;

  constructor(name: string, manager: SpriteManager, id: number, clickFunction?: Function) {
    this.sprite = new Sprite(name, manager);
    this.id = id;
    this.sprite.size = this.size;
    this.sprite.isPickable = true;
    SpriteHelper.AddHotspot(this);
    HoverHelper.AddToHoverList(this.sprite)
    this.clickFunction = clickFunction ? clickFunction : () => {
      trigger('showInfobox', ContentManager.GetContentById(this.id))
      CameraHelper.CreateCameraAnimation(CameraHelper.trackingShots[this.id - 1])
    };
  }

  public set position(position: Vector3) {
    this.sprite.position = position;
  }

}